import { render, staticRenderFns } from "./final.vue?vue&type=template&id=21ec575a&"
import script from "./final.vue?vue&type=script&lang=js&"
export * from "./final.vue?vue&type=script&lang=js&"
import style0 from "./final.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports